var map = {
	"./pantalla-6-1-1.png": "530a",
	"./pantalla-6-1-2.png": "a725",
	"./pantalla-6-1.png": "013b",
	"./pantalla-6-2-1.png": "687c",
	"./pantalla-6-2-2.png": "c2dc",
	"./pantalla-6-3-1.png": "7dfd",
	"./pantalla-6-3-2.png": "7e8e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ba7d";